import { useTranslation } from "react-i18next";

export const LangToggle = ({ className = "" }: { className?: string }) => {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);

  const set = (lng: "en" | "pt") => {
    if (lng === current) return;
    i18n.changeLanguage(lng);
    document.documentElement.lang = lng === "pt" ? "pt-BR" : "en";
  };

  const base =
    "text-[11px] uppercase tracking-[0.2em] transition-colors px-1.5 py-1";

  return (
    <div
      className={`inline-flex items-center gap-1 border border-border rounded-full px-2 py-0.5 ${className}`}
      role="group"
      aria-label="Language"
    >
      <button
        type="button"
        onClick={() => set("en")}
        className={`${base} ${current === "en" ? "text-foreground" : "text-muted-foreground hover:text-foreground"}`}
        aria-pressed={current === "en"}
      >
        EN
      </button>
      <span className="text-muted-foreground/40 text-[10px]">/</span>
      <button
        type="button"
        onClick={() => set("pt")}
        className={`${base} ${current === "pt" ? "text-foreground" : "text-muted-foreground hover:text-foreground"}`}
        aria-pressed={current === "pt"}
      >
        PT
      </button>
    </div>
  );
};
